import { getBackendBaseUrl } from "./backendDiscovery";

function buildProjectCommitPayload(projects) {
  if (!Array.isArray(projects)) {
    return [];
  }

  return projects
    .map((project) => ({
      projectId: project?.id || "",
      repositoryUrl: project?.repositoryUrl || "",
    }))
    .filter((project) => project.projectId && project.repositoryUrl);
}

export async function fetchPortfolioCommitRanges(projects = []) {
  const baseUrl = await getBackendBaseUrl();
  const response = await fetch(`${baseUrl}/api/portfolio/commits`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      projects: buildProjectCommitPayload(projects),
    }),
  });

  if (!response.ok) {
    throw new Error(`Falha ao buscar commits do portfolio (${response.status}).`);
  }

  const payload = await response.json();
  const items = Array.isArray(payload?.projects) ? payload.projects : [];

  return items.reduce((accumulator, item) => {
    if (!item?.projectId) {
      return accumulator;
    }

    const commits = Array.isArray(item.commits)
      ? item.commits
          .filter((commit) => commit && commit.sha && commit.date)
          .map((commit) => ({
            sha: commit.sha,
            date: commit.date,
            message: commit.message || "",
            url: commit.url || "",
            author: commit.author || "",
          }))
      : [];

    accumulator[item.projectId] = {
      repository: item.repository || null,
      repositoryUrl: item.repository ? `https://github.com/${item.repository}` : null,
      commitStart: item.commitStart || null,
      commitEnd: item.commitEnd || null,
      commitStartSha: item.commitStartSha || null,
      commitEndSha: item.commitEndSha || null,
      commits,
      error: item.error || null,
    };
    return accumulator;
  }, {});
}
